// snackbarReducer.ts
import { SnackbarState } from '../../interfaces/common/ui/ISnackbarState';
import { COMMON } from "../../constants/common";

const initialState: SnackbarState = {
  open: false,
  message: '',
  severity: 'info',
};

const snackbarReducer = (state = initialState, action: any): SnackbarState => {
  switch (action.type) {
    case COMMON.SHOW_SNACKBAR:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    case COMMON.HIDE_SNACKBAR:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default snackbarReducer;